<template>
  <NavView></NavView>
    <SideBar></SideBar>
<div class="container-fluid mb-5" >
    <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
    <h6 class="manage-boder pt-2 font1 font-bold1 ps-1"> <router-link class="decoration" to="/mrentedvehicles/index"> Manage Rented Vehicles </router-link></h6>
    
    <br>
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <input class="form-control me-2 width7 " type="search" placeholder="Search" aria-label="Search">
      <router-link class="line1 btn btn-primary text-light border-radius0 " to="/miinventory/index"> Rental Calender</router-link> 
      <router-link class="line1 btn btn-primary text-light border-radius0" to="/mrentedvehicles/create">Create Rental VIN</router-link> 
    </div>
    <br>



<Table id=""  class="table table-hover">
  <thead>
    <tr>
      <th>ID</th>
      <th>VIN No</th>
      <th>Issued Date</th>
      <th>Customer</th>
      <th>Brand</th>
      <th>Email</th>
      <th>Model</th>
      <th>Reg. No.</th>
      <th>Sales Person.</th>
      <th>Created Date</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>
  </thead>
 
    
 
  <tbody>
   
    <!-- v-for="key in count" :key="key" -->
    <tr v-for="mrentedvehicle in mrentedvehicles" :key="mrentedvehicle" >
      <th>{{mrentedvehicle.idStockIssue}}</th>
      <td> {{mrentedvehicle.SI_issueNum}} </td>
      <td>{{mrentedvehicle.issues_date}}</td>
      <td>{{mrentedvehicle.id_customer}}</td>
      <td>{{mrentedvehicle.name_brand}}</td>
      <td></td>
      <td>{{mrentedvehicle.name_model}}</td>
      <td>{{mrentedvehicle.serial_no}}</td>
      <td></td>
      <td></td>
      <td >{{mrentedvehicle.SI_status}}</td>
     <!--  <td ><span class="badge badge-danger border-radius0">Innactive</span></td> -->
     
      <td class="">
        <!-- <CButton  color="primary" size="sm" >view</CButton> -->
        <!-- <router-link :to="{ name: 'McustomerView', params:{ id : mcustomer.idCustomer} }" class=" btn btn-primary  btn-sm text-light " >View</router-link>  -->
        <button v-on:click="viewload(mrentedvehicle.idStockIssue)" class=" btn btn-primary  btn-sm  text-light me-1 mb-1">View </button>
        <button class=" btn btn-primary  btn-sm  text-light me-1 mb-1">Print </button>
        <button v-on:click="createinvoiceload(mrentedvehicle.idStockIssue)" class=" btn btn-primary  btn-sm  text-light mb-1">Create Rental Invoice </button>
        
        
      </td>
    </tr>
    
    
  </tbody>
</Table>
<nav aria-label="Page navigation example">
  <ul  class="pagination justify-content-end">
    <li class="page-item"><a class="page-link" href="#">Previous</a></li>
    <li v-for="key in totalItem" :key="key" class="page-item " >
      <a class="page-link" v-on:click="page(key)" >{{key}}</a>
    </li>
 
   
    <li class="page-item">
      <a class="page-link" >Next</a>
    </li>
  </ul>
</nav>



</div>
<!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
<!-- <form @submit.prevent="del()" class="" >
 <input type="text" v-model="user.id"  class="form-control" >
 <button  type="" class="btn btn-success" >delete</button>
 </form> -->

</template>

<script>
 //import {   CButton, } from '@coreui/vue';
 //import httpClient from '@/axios';
 import axios from 'axios';
 import authService from '@/auth.service';
 import NavView from '../../components/NavView.vue'
  import SideBar from '../../components/SideBar.vue'



export default {
    components:{ 
      NavView,SideBar
    },

    mounted(){
  this.loadMrentedvehicles()
    },
   

    data(){
    return{
      
      mcustomers:'',
      access_token:authService.isLoggedIn(),
     
      mrentedvehicles:'',
        

      
  
     
    };
    },


   methods:{ 
    viewload(id) {
   console.log(); 
   this.$router.push('/mrentedvehicles/view?data='+id); 
        //this.$refs.table.innerHTML = response.data.success;
        
  } ,

  createinvoiceload(id) {
   console.log(); 
   this.$router.push('/sinvoice/createrentalinvoice?id='+id); 
        //this.$refs.table.innerHTML = response.data.success;
        
  } ,


    async loadMrentedvehicles() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/web/api/istockissue/index',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.mrentedvehicles = data.item_list;
       this.totalItem = Math.ceil((data.totalItems)/10);
    } catch (error) {
      console.log(error.response);
    }
  },

  async page(pageid){
  this.$router.push('/mrentedvehicles/index?page='+pageid); 
  try {
        const { data} = await  axios.get('/web/api/istockissue/index?page='+pageid,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type':'application/json',
         
        }
       });
       console.log(data);
       this.mrentedvehicles = data.item_list;
       this.totalItem = Math.ceil((data.totalItems)/10);
       



      } catch (error) {
        console.log(error.response);
      }
    
  }, 
   

}




};

</script>

<style scoped>
.button1{
  width: 10px !important;
}
.border1{
  border: none;
  background-color: #0d6efd;
}
.font-color1:hover{
  color: black !important;
  cursor: pointer;
}
.manage-boder{
  border-bottom: 1px solid #E9E9E3;
  border-top: 1px solid #E9E9E3;
}
.border-radius0{
      border-radius:0px !important ;
}
.font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold;
    }
    .manage-boder{
    border-bottom: 2px solid #E9E9E3;
    border-top: 2px solid #E9E9E3;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold !important;
    }
    .colr1{
        color:#A5A5A3;
        
    }
    .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }
  .width7{
    width: 250px;
  }

</style>